import { useFormContext } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { MIDDLE_INITIAL_INPUT_MAX_LEGTH } from './config';

type Props = Pick<RootInputProps, 'name' | 'label' | 'required' | 'containerClassName'>;

const MiddleInitialInput = (props: Props) => {
  const { name, label, required, containerClassName } = props;

  const { control, clearErrors } = useFormContext();

  return (
    <RootInput
      key="middleInitial"
      name={name}
      label={label}
      control={control}
      clearErrors={clearErrors}
      maxLength={MIDDLE_INITIAL_INPUT_MAX_LEGTH}
      autoComplete={uuidv4()}
      containerClassName={containerClassName}
      required={required}
    />
  );
};

export default MiddleInitialInput;
